import { fields$ } from './fields$';
import { map } from 'rxjs/operators';
import { keyBy, uniqBy } from 'lodash';
import { pairDateRangeFields } from '@ardoq/date-range';
import { Observable } from 'rxjs';
import { fieldOps } from 'models/utils/fieldOps';
import { APIFieldAttributes, FieldGlobalAttributes } from '@ardoq/api-types';
import { ObservableState, toPersistentStream } from '@ardoq/rxbeach';

export type GlobalFieldsState = {
  models: FieldGlobalAttributes[];
  byName: Record<string, FieldGlobalAttributes>;
};

const toGlobalFieldsState = (
  fields: APIFieldAttributes[]
): GlobalFieldsState => {
  const pairedFields = pairDateRangeFields(fields);
  const dedupedFields = uniqBy(pairedFields, 'name');
  const globalFields = dedupedFields.map(fieldOps.toGlobalField);

  return {
    models: globalFields,
    byName: keyBy(globalFields, 'name'),
  };
};

const globalFields$Internal: Observable<GlobalFieldsState> = fields$.pipe(
  map(({ models }) => toGlobalFieldsState(models))
);

export const globalFields$: ObservableState<GlobalFieldsState> =
  toPersistentStream('globalFields$', globalFields$Internal, {
    models: [],
    byName: {},
  });
